// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vWloZ","input":"styles_input__2WGPm"};